/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Table } from '@material-ui/core';
import FOTableHead from './foTableHead/FOTableHead';
import FOTableBody from './foTableBody/FOTableBody';
import FOTableFooter from './foTableFooter/FOTableFooter';

const useStyles = makeStyles(theme => ({
  ...theme.customTheme,
  tableWrapper: {
    overflowX: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '2rem',
    },
  },
  layout: {
    [theme.breakpoints.up('lg')]: {
      tableLayout: 'fixed',
    },
  },
}));

export default function FOTable({
  columns,
  rows,
  data,
  totalCount,
  loading,
  page,
  pageSize,
  updatePageAction,
  updatePageSizeAction,
  tableConfiguration,
  isAllSelected,
  handleSelectAll,
  getSortOrderForColumn,
  onClickColumn,
  isRowSelected,
  handleSelectRow,
  handleActionMenuClick,
  getActionsTooltipText,
  filter,
  setFilter,
  emptyTableData,
  selectedRow,
  anchorActionMenu,
  computeActionEntries,
  computeCombinedCellEntries,
  emptyTableSuggestion,
  isAddressBookPage,
  emptyTableWarningMessage,
  error,
}) {
  const classes = useStyles();

  const tableConfig = tableConfiguration?.table;

  return (
    <>
      {loading || !tableConfig ? (
        <CircularProgress size={24} />
      ) : (
        <div className={classes.tableWrapper}>
          <Table size={tableConfig.size} className={classes.layout}>
            {tableConfig.hasHeader && (
              <FOTableHead
                isAllSelected={isAllSelected}
                handleSelectAll={handleSelectAll}
                getSortOrderForColumn={getSortOrderForColumn}
                onClickColumn={onClickColumn}
                columns={columns}
                config={tableConfig}
              />
            )}
            <FOTableBody
              emptyTableSuggestion={emptyTableSuggestion}
              emptyTableWarningMessage={emptyTableWarningMessage}
              rows={rows}
              data={data}
              isRowSelected={isRowSelected}
              handleSelectRow={handleSelectRow}
              handleActionMenuClick={handleActionMenuClick}
              getActionsTooltipText={getActionsTooltipText}
              isAddressBookPage={isAddressBookPage}
              filter={filter}
              setFilter={setFilter}
              emptyTableData={emptyTableData}
              selectedRow={selectedRow}
              tableConfiguration={tableConfiguration}
              anchorActionMenu={anchorActionMenu}
              computeCombinedCellEntries={computeCombinedCellEntries}
              computeActionEntries={computeActionEntries}
              error={error}
            />
          </Table>
          {tableConfig.hasFooter && (
            <FOTableFooter
              totalCount={totalCount}
              page={page}
              pageSize={pageSize}
              setPage={updatePageAction}
              setPageSize={updatePageSizeAction}
            />
          )}
        </div>
      )}
    </>
  );
}

FOTable.defaultProps = {
  tableConfig: {
    size: 'small',
    hasHeader: true,
    hasFooter: true,
  },
};
